import './Projects.css';
import futbolImg from '../assets/futbolxl.png';
import musicandoImg from '../assets/musicando.png';
import nextImg from '../assets/nextjs14.png';
import angularImg from '../assets/angular18.png';
import reactImg from '../assets/react.png';
import calculadoraImg from '../assets/calculadorainfantil.png';

const projectsData = [
  {
    id: 1,
    title: 'Futbol XL',
    description: 'E-commerce de venta de botines con sistema de gestión de stock. Trabajo final del bootcamp.',
    tech: ['JavaScript', 'MySQL', 'Sequelize', 'CSS', 'HTML'],
    demoUrl: '#',
    githubUrl: '#',
    image: futbolImg,
    gradient: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
  },
  {
    id: 2,
    title: 'Musicando',
    description: 'CRUD de canciones por artista con base de datos relacional.',
    tech: ['Node.js', 'Express', 'MySQL'],
    demoUrl: '#',
    githubUrl: '#',
    image: musicandoImg,
    gradient: 'linear-gradient(135deg, #a855f7 0%, #d946ef 100%)',
  },
  {
    id: 3,
    title: 'Next.js 14',
    description: 'Aplicación de práctica para explorar Next.js 14 y su App Router.',
    tech: ['Next.js', 'React', 'Vercel'],
    demoUrl: '#',
    githubUrl: '#',
    image: nextImg,
    gradient: 'linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%)',
  },
  {
    id: 4,
    title: 'Angular 18',
    description: 'Aplicación de práctica explorando las nuevas features de Angular 18.',
    tech: ['Angular 18', 'TypeScript'],
    demoUrl: '#',
    githubUrl: '#',
    image: angularImg,
    gradient: 'linear-gradient(135deg, #6d28d9 0%, #a855f7 100%)',
  },
  {
    id: 5,
    title: 'React Tasks',
    description: 'Aplicación de gestión de tareas para profundizar en React Hooks y manejo de estado.',
    tech: ['React', 'Hooks', 'JavaScript'],
    demoUrl: '#',
    githubUrl: '#',
    image: reactImg,
    gradient: 'linear-gradient(135deg, #7c3aed 0%, #c084fc 100%)',
  },
  {
    id: 6,
    title: 'Calculadora de Dosis Pediátrica',
    description: 'Aplicación móvil para calcular dosis de medicación infantil según peso y edad del niño.',
    tech: ['Flutter', 'Dart', 'Mobile'],
    demoUrl: '#',
    githubUrl: '#',
    image: calculadoraImg,
    gradient: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
  },
];

const Projects = () => {
  return (
    <section className="projects" id="proyectos">
      <div className="projects-container">
        <div className="section-number">03 — Proyectos</div>
        <h2 className="section-title">Trabajos seleccionados</h2>

        <div className="projects-grid">
          {projectsData.map((project) => (
            <article key={project.id} className="project-card">
              <div
                className="project-image"
                style={{
                  background: project.image
                    ? `url(${project.image}) center/cover`
                    : project.gradient,
                }}
              >
                {!project.image && <span>[ captura del proyecto ]</span>}
              </div>
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tech">
                  {project.tech.map((t) => (
                    <span key={t} className="project-tech-tag">
                      {t}
                    </span>
                  ))}
                </div>
                <div className="project-links">
                  <a href={project.demoUrl} className="project-link project-link-primary">
                    Demo →
                  </a>
                  <a href={project.githubUrl} className="project-link">
                    GitHub
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
